import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [_vm.regionForm.canManageRegions ? _c("div", {
    staticClass: "flex justify-end mb-4"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: ""
    },
    on: {
      click: function click($event) {
        return _vm.startAddRegion();
      }
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-plus mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" New region ")], 1)], 1) : _vm._e(), _c("div", {
    staticClass: "content-regions container-centered small"
  }, _vm._l(_vm.countries, function (country) {
    return _c("div", {
      key: country.id_country,
      staticClass: "country"
    }, [_c("div", {
      staticClass: "country-title"
    }, [_vm._v(" " + _vm._s(country.printable_name.toUpperCase()) + " ")]), _c("div", {
      staticClass: "country-regions"
    }, [_c("div", {
      staticClass: "regions-list"
    }, _vm._l(country.regions, function (region, index) {
      return _c("div", {
        key: index,
        staticClass: "region-container",
        attrs: {
          id: "region-" + region.id
        }
      }, [_c("router-link", {
        staticClass: "router-link --no-hover-underlined",
        attrs: {
          to: region.nbProducers > 0 ? _vm.selectRegion(region.id) : "#"
        }
      }, [_c("div", {
        staticClass: "region",
        class: [region.nbProducers === 0 ? "region-disabled" : null]
      }, [_c("div", {
        staticClass: "region-img-container"
      }, [_c("div", {
        staticClass: "region-img"
      }, [!_vm.imagesBroken.includes(region.id) && region.imageThumbnail != null && region.imageThumbnail.length > 0 ? _c("img", {
        attrs: {
          src: region.imageThumbnail,
          alt: ""
        },
        on: {
          error: function error($event) {
            return _vm.imagesBroken.push(region.id);
          }
        }
      }) : !_vm.imagesBroken.includes(region.id) && region.image != null && region.image.length > 0 ? _c("img", {
        attrs: {
          src: region.image,
          alt: ""
        },
        on: {
          error: function error($event) {
            return _vm.imagesBroken.push(region.id);
          }
        }
      }) : _c("img", {
        attrs: {
          src: require("@/assets/images/_temp/wine-detail-gallery.jpg"),
          alt: ""
        }
      })]), region.nbProducers === 0 ? _c("div", {
        staticClass: "region-disabled-filigree"
      }, [_vm._v(" Curated selection on demand ")]) : _vm._e(), _c("div", {
        staticClass: "label-region"
      }, [_c("label", [_vm._v(_vm._s(region.name))])])])])]), _vm.regionForm.canManageRegions ? _c("div", {
        staticClass: "flex justify-center mt-2"
      }, [_c("span", {
        staticClass: "text-smaller router-link",
        on: {
          click: function click($event) {
            return _vm.openEditRegion(region.id);
          }
        }
      }, [_vm._v(" Edit ")])]) : _vm._e()], 1);
    }), 0)])]);
  }), 0), _vm.regionForm.canManageRegions ? _c("RegionFormModal", {
    ref: "regionForm",
    attrs: {
      id: _vm.regionForm.editedId,
      loggedUserData: _vm.loggedUserData
    },
    on: {
      entityUpdated: function entityUpdated($event) {
        return _vm.getRegionsOfType();
      },
      closed: function closed($event) {
        _vm.regionForm.editedId = null;
      }
    }
  }) : _vm._e(), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };